import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  progress: PropTypes.number, // 0-100
  className: PropTypes.string,
  slim: PropTypes.bool,
};

export default function AtomProgressBar({ progress = 0, className, slim = false }) {
  let progressWidth;

  if (progress === null) {
    return null;
  } else if (progress > 100) {
    progressWidth = "100%";
  } else if (progress <= 0) {
    progressWidth = 0;
  } else {
    progressWidth = `${progress}%`;
  }

  return (
    <div data-test-id="progress-bar" className={`progress-bar ${slim ? "slim" : ""} ${className}`}>
      <div data-test-id="progress-bar-background" className="progress-bar-background"></div>
      <div data-test-id="progress-bar-inner" className="progress-bar-inner" style={{ width: progressWidth }}></div>
    </div>
  );
}

AtomProgressBar.propTypes = propTypes;
